<template>
  <div>
    <router-view/>
  </div>
</template>
<script>
export default {
};
</script>


// WEBPACK FOOTER //
// src/components/router/Router.vue